import { useEffect, useState } from "react";
import { ShieldCheck, Zap, Download, Code2 } from "lucide-react";
import { PublicLayout } from "../components/Common";
import api from "../lib/api";
import { mediaUrl } from "../lib/format";

export default function About() {
  const [page, setPage] = useState(null);
  useEffect(() => {
    document.title = "Tentang - DS KODE";
    api.get("/pages/tentang").then((r) => setPage(r.data)).catch(() => {});
  }, []);
  return (
    <PublicLayout>
      <div className="bg-slate-900">
        <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-10 py-12 md:py-14">
          <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(360px,0.8fr)]">
            <div className="order-2 lg:order-1">
              <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-indigo-300 mb-3"><Code2 className="h-4 w-4" /> Tentang Kami</span>
              <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-white">DS KODE</h1>
              <p className="text-justify text-slate-300 mt-4 max-w-4xl text-sm sm:text-base leading-7 whitespace-pre-line">
                {page?.content || "DS KODE adalah marketplace digital untuk aplikasi, template, script, dan source code berkualitas."}
              </p>
            </div>
            {(page?.video || page?.image) && (
              <div className="order-1 lg:order-2 overflow-hidden rounded-2xl border border-white/10 bg-slate-800 shadow-2xl">
                {page?.video ? <video src={mediaUrl(page.video)} autoPlay muted loop playsInline className="aspect-video w-full object-cover" /> : <img src={mediaUrl(page.image)} alt="Tentang DS KODE" className="aspect-video w-full object-cover" />}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-10 py-10 md:py-12">
        <div className="mb-8 max-w-4xl">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-indigo-600">Kenapa DS KODE</p>
          <h2 className="mt-2 font-heading text-xl font-bold text-slate-900 sm:text-2xl">Solusi digital yang siap digunakan</h2>
        </div>
        <div className="grid sm:grid-cols-3 gap-5">
        {[
          { icon: ShieldCheck, title: "Aman", desc: "Semua file terlindungi dan hanya dapat diunduh oleh member terverifikasi." },
          { icon: Zap, title: "Cepat", desc: "Platform ringan dengan performa optimal di segala perangkat." },
          { icon: Download, title: "Berkualitas", desc: "Produk dikurasi dengan dokumentasi lengkap & update berkala." },
        ].map((f) => (
          <div key={f.title} className="bg-white rounded-xl border border-slate-200 p-6 text-center">
            <span className="grid place-items-center h-12 w-12 rounded-xl bg-indigo-50 text-indigo-600 mx-auto mb-3"><f.icon className="h-6 w-6" /></span>
            <h3 className="font-heading font-semibold text-slate-900">{f.title}</h3>
            <p className="text-sm text-slate-500 mt-1.5">{f.desc}</p>
          </div>
        ))}
        </div>
      </div>
    </PublicLayout>
  );
}
